<template>
  <section class="login-content">
    <div class="main">
      <div class="loginlogo"><img src="../img/ico.png"/></div>
      <form class="first" @submit="submit" @input="clearWarning">
        <div class="username">
          <input type="text" v-model="username" @keypress.enter="submit" placeholder="Username" autocomplete="off"/>
        </div>
        <div class="password">
          <input type="password" v-model="password" @keypress.enter="submit" placeholder="Password" autocomplete="off"/>
        </div>
        <div class="buttons">
          <div class="error">{{msg}}</div>
          <button type="button" class="form-btn" @click="submit">Log In</button>
          <button type="button" class="form-btn" @click="toRegister">Register</button>
        </div>
      </form>
      <router-link class="register_link" to="/forgetPwd">Forget Your Password?</router-link>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { login } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        username: '',
        password: '',
        msg: '',
        showForgotten: false
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'login_', 'username_', 'password_',
        'submit_', 'clickToRegister_', 'forgotPwd_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      clearWarning () {
        this.msg = ''
      },
      submit () {
        const uid = this.username
        if (!uid) {
          this.msg = this.i18n.invalidUsername
          return
        }

        login(uid, hash(uid, this.password))
          .then((data) => {
            this.profile.name = this.username
            this.$router.push('/profile')
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      toRegister () {
        this.$router.push('/register')
      },
      forgot_password () {
        this.showForgotten = !this.showForgotten
      }
    },
    created () {
      if (this.gameOver) return this.$router.replace('/rank')
    }
  }
</script>

<style lang="less" scoped>
.before(@width: 32px, @height: 40px, @margin-top: 15px, @margin-left: 5px){
  content: '';
  width: @width;
  height: @height;
  position: absolute;
  margin-top: @margin-top;
  margin-left: @margin-left;
  z-index: 2;
}
.login-content {
    .main {
        .loginlogo{
          text-align: center;
          margin-top: 50px;
          >img{
            width: 150px;
        }
        }
        .first {
            width: auto;
            div {
                width:500px;
                margin-top: 20px;
                input {
                    font-size: 16px;
                    line-height: 60px;
                    border-bottom: 1px solid #fff;
                }

                &.buttons {
                    margin-top: 0px;
                    text-align: center;
                    .form-btn{
                      width: 150px;
                      color: #00c8e3;
                      height: 45px;
                      border: 1px solid #00c8e3;
                      font-size: 18px;
                      background: transparent;
                    }
                    .error {
                      height: 55px;
                    }
                    .form-btn:last-child {
                        margin-left: 50px;
                    }
                }
            }
            input {
              display: inline-block;
              margin-top: 10px;
              color: #fff;
              font-size: 16px;
              font-family: 'Courier';
              line-height: 60px;
              height: 60px;
              width: 498px;
              padding-left: 50px;
              border: none;
              outline: none;
              background: none;
              border-bottom: 1px solid #fff;

          }
            .username::before{
              .before();
              background: url('../img/username.png') no-repeat bottom left /28px;
            }
            .password::before{
              .before();
              background: url('../img/password.png') no-repeat bottom left /28px;
            }
        }
    }
}



</style>




// WEBPACK FOOTER //
// src/themes/dragon/components/login.vue